import React, { useState } from 'react';

import CustomDropdown from '@components/CustomDropdown';
import LoaderComponent from '@components/LoaderComponent';
import DateRangeComponent from '@components/DateRangeComponent';

import {
	downloadFabricInventoryReport,
	downloadGMVReport,
	downloadNMVReport,
	downloadNotificationReport,
	downloadSKUReport,
	downloadUpdateTrackerReport
} from '@services/commonService';

import { downloadBlobFIle, getShortName, printApiError } from '@utils/Util';

const UserReport = () => {
	const [reportNameList] = useState([
		{ id: 1, value: 'GMV' },
		{ id: 2, value: 'NMV' },
		{ id: 3, value: 'SKU QR' },
		{ id: 4, value: 'Notification' },
		{ id: 5, value: 'Update Tracker' },
		{ id: 6, value: 'Fabric Inventory' }
	]);
	const [loader, setLoader] = useState(false);
	const [selectedReportName, setSelectedReportName] = useState('');
	const [fromDate, setFromDate] = useState('');
	const [toDate, setToDate] = useState('');
	const [selectedFile, setSelectedFile] = useState(null);
	const [downlodUrl, setDownlodUrl] = useState('');
	const [downloadValue, setDownloadValue] = React.useState('');

	const handleChange = (e) => {
		const inputValue = e.target.value;
		const numericValue = parseInt(inputValue);

		if (!isNaN(numericValue) && numericValue <= 250) {
			setDownloadValue(numericValue);
		} else if (inputValue === '') {
			setDownloadValue('');
		}
	};

	const onItemClick = (item) => {
		setSelectedReportName(item.value);
	};

	const handleReportSearch = () => {};

	const onChangeDateRange = async (value1, value2) => {
		setFromDate(value1);
		setToDate(value2);
	};

	const handleSubmit = async () => {
		try {
			setLoader(true);
			let params = '?';
			let notificationParams = `?page=0&size=${downloadValue}&sort=id,desc`;
			if (fromDate && toDate) {
				params += 'startDate=' + fromDate + '&endDate=' + toDate;
			}
			if (selectedReportName === 'GMV') await downloadGMVReport(params);
			if (selectedReportName === 'NMV') await downloadNMVReport(params);
			if (selectedReportName === 'Fabric Inventory') await downloadFabricInventoryReport(params);
			if (selectedReportName === 'Notification') await downloadNotificationReport(notificationParams);
			setLoader(false);
		} catch {
			setLoader(false);
		}
	};

	const downloadFile = (url) => {
		if (url) {
			window.open(url, '_blank');
		}
	};

	const handleSKUQRReportDownload = async (formData) => {
		const { data } = await downloadSKUReport(formData);
		if (data) {
			setDownlodUrl(data);
			downloadFile(data);
		}
	};

	const handleUpdateTrackerReportDownload = async (formData) => {
		const response = await downloadUpdateTrackerReport(formData);
		if (response) {
			downloadBlobFIle(response);
			setLoader(false);
		}
	};

	const handleUploadExcelFile = async (e) => {
		const file = e.target.files[0];

		if (!file) return;

		setLoader(true);
		setSelectedFile(file);

		try {
			const formData = new FormData();
			formData.append('file', file);

			if (selectedReportName === 'SKU QR') {
				await handleSKUQRReportDownload(formData);
			} else {
				await handleUpdateTrackerReportDownload(formData);
			}
		} catch (error) {
			printApiError(error);
		} finally {
			setLoader(false);
		}
	};

	const renderFileUploadButton = () => (
		<div className="button size36 outline mr-3">
			<label htmlFor="tna-file-upload" className="cursor-pointer">
				<img
					src={`${process.env.PUBLIC_URL}/icons/upload-dark.svg`}
					alt="upload"
					className="upload-icon mr-1"
				/>
				{selectedFile?.name ? `${getShortName(selectedFile?.name, 10)}.xlsx` : 'Upload File'}
			</label>
			<input
				id="tna-file-upload"
				type="file"
				accept=".xlsx, .xls"
				className="file-upload d-none"
				onChange={handleUploadExcelFile}
			/>
		</div>
	);

	const renderNotificationInput = () => (
		<input
			type="number"
			placeholder="Max 250"
			className="mr-3"
			style={{ width: '174px' }}
			max={250}
			value={downloadValue}
			onChange={handleChange}
		/>
	);

	const renderDateRangeInput = () => (
		<DateRangeComponent
			item={{ value1: fromDate, value2: toDate }}
			onChange={onChangeDateRange}
			itemId={1}
		/>
	);

	const renderInputFieldByReport = () => {
		switch (selectedReportName) {
			case 'SKU QR':
			case 'Update Tracker':
				return renderFileUploadButton();
			case 'Notification':
				return renderNotificationInput();
			default:
				return renderDateRangeInput();
		}
	};

	return (
		<LoaderComponent loading={loader}>
			<div className="body-content">
				<div className="form-container">
					<div className="row">
						<div className="col-md-3 pr-1">
							<CustomDropdown
								type="addItem"
								title={'Report Name'}
								onItemClick={onItemClick}
								items={reportNameList}
								selectedItem={selectedReportName}
								onItemSearch={handleReportSearch}
								hideSearchBox={true}
							/>
						</div>
						<div className="col-md-3 pl-1 pr-0">{renderInputFieldByReport()}</div>
						<div className="col-md-3 pl-0">
							{['SKU QR', 'Update Tracker'].includes(selectedReportName) &&
								downlodUrl !== '' && (
									<button
										onClick={() => downloadFile(downlodUrl)}
										className="button size32"
										disabled={!downlodUrl}
									>
										Download
									</button>
								)}
							{!['SKU QR', 'Update Tracker'].includes(selectedReportName) && (
								<button onClick={handleSubmit} className="button size32">
									Search
								</button>
							)}
						</div>
					</div>
				</div>
			</div>
		</LoaderComponent>
	);
};

export default UserReport;
